/**
 * B&Y APPLICATION FRONTEND
 * (c) 2025
 */

/**
 * POLYFILLS
 */
import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = window.ResizeObserver || ResizeObserver

/**
 * JUPITER IMPORTS
 */
import {
  Application,
  // Cookies,
  Events,
  Lazyload,
  Links,
  MobileMenu,
  Moonwalk,
  FixedHeader,
  Toggler,
  Typography,
  animate,
  Dom,
  Dataloader,
  Looper,
} from '@brandocms/jupiter'

/**
 * APP SPECIFIC MODULE IMPORTS
 */

import AutoSizer from './modules/AutoSizer'
import SmartVideo from './modules/SmarterVideo'
import AlmaReactiveText from './modules/AlmaReactiveText'

/**
 * CONFIG IMPORTS
 */
import configureBreakpoints from './config/BREAKPOINTS'
import configureHeader from './config/HEADER'
import configureMobileMenu from './config/MOBILE_MENU'
import configureMoonwalk from './config/MOONWALK'

import '../css/app.css'

console.log('—— Ytri v1.0.3')

const app = new Application({
  respectReducedMotion: false,
  breakpointConfig: configureBreakpoints,
  faderOpts: {
    fadeIn: callback => {
      if (Dom.hasClass(document.documentElement, 'is-live-preview')) {
        animate('.fader', { display: 'none' }, { duration: 0 })
        document.body.classList.remove('unloaded')
        callback()
        return
      }

      animate('.fader', { opacity: 0 }, { duration: 0.5, delay: 0.2 }).then(() => {
        if (window.bfTO) {
          clearTimeout(window.bfTO)
        }
        animate('.fader', { display: 'none' }, { duration: 0 })
        document.body.classList.remove('unloaded')
      })
      callback()
    },
  },
})

app.registerCallback(Events.APPLICATION_READY, () => {
  app.links = new Links(app, {
    triggerEvents: false,
    mobileMenuDelay: 150,
    scrollOffsetNav: true,
  })
  app.lazyload = new Lazyload(app, { useNativeLazyloadIfAvailable: false })
})

app.registerCallback(Events.APPLICATION_PRELUDIUM, () => {
  app.moonwalk = new Moonwalk(app, configureMoonwalk(app))
  app.header = new FixedHeader(app, configureHeader(app))
  app.mobileMenu = new MobileMenu(app, configureMobileMenu(app))

  // Old GTM code - Commented out per SEO agency instructions
  // GTM is now loaded directly in _layout.twig <head> section
  /*
  const setGTM = () => {
    console.log('-> sgtm')
    function gtag() {
      dataLayer.push(arguments)
    }

    gtag('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted',
    })

    // Load gtag.js script.
    const gtmId = 'GTM-WN4RCRNV'
    var gtmScript = document.createElement('script')
    gtmScript.async = true
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`

    var firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(gtmScript, firstScript)
  }
  */

  // app.cookies = new Cookies(app, {
  //   setCookies: () => {
  //     setGTM()
  //   },
  //   alreadyConsented: () => {
  //     setGTM()
  //   },
  // })

  app.typo = new Typography()
  app.togglers = []

  // Initialize Looper for image stacks with custom config
  app.looper = new Looper(app, {
    speed: {
      sm: 0.05, // Very slow on mobile for better image viewing
      lg: 0.15, // Slower on desktop for image viewing
    },
    ease: {
      mouseOver: { speed: 0.1, duration: 0.75 }, // Almost stop on hover
      mouseOut: { speed: 0.15, duration: 0.75 }, // Resume slow movement
    },
    crawl: true,
  })

  const togglers = Dom.all('[data-toggle]')
  togglers.forEach(toggleEl => {
    app.togglers.push(new Toggler(app, toggleEl))
  })

  new AutoSizer(undefined, { maxWidthCh: 30, padding: 2 })

  // Alma reactive text — only init on alma page
  if (document.body.classList.contains('alma')) {
    app.almaReactiveText = new AlmaReactiveText(app)
  }

  const $smartVideos = document.querySelectorAll('[data-smart-video]')
  app.smartVideos = []
  Array.from($smartVideos).forEach(v => {
    const video = new SmartVideo(app, v, true)
    app.smartVideos.push(video)
  })

  app.dataloaders = []

  const loaderEls = Dom.all('[data-loader]')
  Array.from(loaderEls).forEach(loaderEl => {
    app.dataloaders.push(
      new Dataloader(app, loaderEl, {
        onFetch: dataloader => {
          console.log('Data loaded:', dataloader)
          const mw = new Moonwalk(app, configureMoonwalk(app), dataloader.$canvasEl)
          new Lazyload(app, { useNativeLazyloadIfAvailable: false }, dataloader.$canvasEl)
          mw.ready()
        },
      }),
    )
  })

  // const bookingPicker = Dom.find('.stay-dates input.start')

  // if (bookingPicker) {
  // const endElement = Dom.find('.stay-dates input.end')
  // const _picker = new easepick.create({
  //   element: bookingPicker,
  //   css: [
  //     'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
  //     '/assets/extra-css/calendar.css',
  //   ],
  //   plugins: [RangePlugin, LockPlugin],
  //   format: 'DD/MM/YY',
  //   zIndex: 1000,
  //   LockPlugin: {
  //     minDate: new Date(),
  //     inseparable: true,
  //   },
  //   RangePlugin: {
  //     elementEnd: endElement,
  //     tooltipNumber(num) {
  //       return num - 1
  //     },
  //     locale: {
  //       one: 'night',
  //       other: 'nights',
  //     },
  //   },
  // })

  // const inputs = Dom.all('.inputs .adults, .inputs .rooms')
  // Array.from(inputs).forEach(inputWrapper => {
  //   inputWrapper.querySelector('.arrow.left').addEventListener('click', () => {
  //     const input = inputWrapper.querySelector('.custom-number-input input')
  //     input.stepDown()
  //   })

  //   inputWrapper.querySelector('.arrow.right').addEventListener('click', () => {
  //     const input = inputWrapper.querySelector('.custom-number-input input')
  //     input.stepUp()
  //   })
  // })
  // }
})

app.registerCallback(Events.APPLICATION_REVEALED, () => {
  if (app.almaReactiveText) {
    app.almaReactiveText.normalizeFloatSvgs()
  }
})

// trigger ready state
if (
  document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'
) {
  app.initialize()
} else {
  document.addEventListener('DOMContentLoaded', app.initialize.apply(app))
}
